import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TrialExplainerModalComponent } from './trial-explainer-modal.component';
import { ButtonModule } from "@xref/xref-lib";



@NgModule({
  declarations: [TrialExplainerModalComponent],
  imports: [
    CommonModule, ButtonModule
  ],
  exports: [TrialExplainerModalComponent],
})
export class TrialExplainerModalModule { }
